import React, { useState, ReactNode, useRef } from 'react'
import {
  AccordionPanel,
  AccordionHeader,
  AccordionContent,
  AccordionIcon,
  AccordionDefaultTitle,
} from './Accordion.styles'

type AccordionProps = {
  defaultExpanded?: boolean
  label: JSX.Element | string
  children: ReactNode
}

export const Accordion = ({
  label,
  children,
  defaultExpanded = false,
}: AccordionProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggleSection = () => {
    setIsExpanded((prev) => !prev)
  }

  return (
    <AccordionPanel>
      <AccordionHeader onClick={toggleSection}>
        {typeof label === 'string' ? (
          <AccordionDefaultTitle>{label}</AccordionDefaultTitle>
        ) : (
          label
        )}
        <AccordionIcon className={isExpanded ? 'expanded' : ''} />
      </AccordionHeader>
      <AccordionContent
        ref={contentRef}
        style={{
          maxHeight: isExpanded ? `${contentRef.current?.scrollHeight}px` : '0',
        }}
        className={isExpanded ? 'expanded' : ''}
      >
        {children}
      </AccordionContent>
    </AccordionPanel>
  )
}
